import styled from 'styled-components';

export const PropertiesBox = styled.div<{ $itemsCount: number }>`
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 30px 0;
  display: grid;
  grid-template-rows: repeat(
    ${({ $itemsCount }) => Math.round($itemsCount / 2)},
    auto
  );
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    padding: 20px 15px;
  }
`;
